import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { setupWorker } from 'msw';
import { getCurrentQualificationYears, getAppointmentTypes, updatedSelectedAppointmentTypes } from './Redux/Actions/Contract.Globals.Actions';
import { getUserDetail } from './Redux/Actions/User.Actions';
import AppNavigation from './Common/Navigation/AppNavigation.container';
import NoAuthNav from './Common/Navigation/NoAuthNav';
import ToastAlert from './Common/ToastAlert';
import HomePage from './Features/LandingArea/Home';
import ContractManagement from './Features/ContractManagement/ContractManagement.container';
import AppointeeManagement from './Features/AppointeeManagement/AppointeeManagement.container';
import ContractReleasePage from './Features/ContractRelease/ContractRelease.container';
import UploadFiles from './Features/UploadFiles/UploadFiles';
import Utilities from './Features/Utilities/Utilities';
import FeatureFlag from './Common/FeatureFlag/feature-flag';
import { flags } from './Common/FeatureFlag/features';
import { handlers } from './mock-api/handlers';
import { MsalContext, UnauthenticatedTemplate, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest, protectedResources } from './config/authConfig';
import axios from 'http.service';

if (process.env.REACT_APP_API_MODE === 'MOCK') {
	console.warn('Using Mock API');
	const worker = setupWorker(...handlers);
	worker.start();
}

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pageTitle: ''
		};
	}

	render() {
		return (
			<>
				<MsalAuthenticationTemplate
					LoadingComponent={AuthenticationLoading}
					interactionType={InteractionType.Redirect}
					authenticationRequest={loginRequest}
					ErrorComponent={AuthenticationError}
				>
					<AuthenticatedApp {...this.props} />
				</MsalAuthenticationTemplate>

				<UnauthenticatedTemplate>
					Redirecting To Login...
				</UnauthenticatedTemplate>

				<ToastAlert />
			</>
		);
	}
}

const mapStateToProps = state => {
	return {
		...state
	};
};

const mapDispatchToProps = dispatch => {
	return {
		handleGetQualificationYears: async () => await dispatch(getCurrentQualificationYears()),
		handleGetAppointmentTypes: async year => await dispatch(getAppointmentTypes(year)),
		handleUpdateAppointmentTypes: values => dispatch(updatedSelectedAppointmentTypes(values)),
		handleGetUserDetail: async () => dispatch(getUserDetail())
	};
};

const AuthenticationLoading = () => <div>Please wait momentarily while we check your authorisation status</div>;

const AuthenticationError = () => <>
	<NoAuthNav handleUpdateAppointmentTypes={this.props.handleUpdateAppointmentTypes} />
	<div className="App">
		<div className="no-auth-container">
			<div className="no-auth-server">A server error has occured.</div>
			Please refresh your screen to retry
		</div>
	</div>
</>

class AuthenticatedApp extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageTitle: ''
		};
	}
	static contextType = MsalContext;

	componentDidMount = async () => {
		axios.interceptors.request.use(
			async config => {
				const response = await this.context.instance.acquireTokenSilent({
					scopes: protectedResources.contractManagementApi.scopes,
					account: this.context.accounts[0]
				});
				config.headers['Authorization'] = `Bearer ${response.accessToken}`;
			  return config;
			},
			error => {
			  return Promise.reject(error);
			}
		  );

		await this.props.handleGetQualificationYears();
		await this.props.handleGetAppointmentTypes(this.props.contract_globals.qualification_year.selected);
		await this.props.handleGetUserDetail();
	};

	render() {
		return <>
			<AppNavigation handleUpdateAppointmentTypes={this.props.handleUpdateAppointmentTypes} />
			<main>
				<Switch>
					<Route exact path="/" render={() => <HomePage {...this.props} />} />
					<Route path="/contractmanagement" component={ContractManagement} />
					<Route path="/appointeemanagement" component={AppointeeManagement} />
					<Route
						path="/contractrelease"
						render={routeProps => (
							<FeatureFlag flag={flags.BP4} {...routeProps}>
								<ContractReleasePage />
							</FeatureFlag>
						)}
					/>
					<Route path="/uploadfiles" component={UploadFiles} />
					<Route path="/utilities" component={Utilities} />
					<Route path="*" render={() => <HomePage {...this.props} errors={['The route specified was Not Found 404']} />} />
				</Switch>
			</main>
		</>
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);